import * as React from "react";

const CheckIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="11"
    fill="none"
    viewBox="0 0 12 11"
    {...props}
  >
    <path stroke="#fff" strokeWidth="2" d="m.748 5 3.938 3.75 6.562-7.5"></path>
  </svg>
);

export default CheckIcon; 